/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';
import { BackendProductVariantRequestDto } from '../../models/backend-product-variant-request-dto';

export interface SalesProductVariantsCreate$XWwwFormUrlencoded$Params {
  body: BackendProductVariantRequestDto;
}

export function salesProductVariantsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesProductVariantsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductVariantDto>;
    }),
  );
}

salesProductVariantsCreate$XWwwFormUrlencoded.PATH = '/api/sales/product_variants/';
